// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
// import  * as Constants from '../Constants/Constants'

// const StudentsCorner = () => {
//   const [eventData, setEventData] = useState(null); // State to hold event data
//   const [loading, setLoading] = useState(true); // Loading state
//   const [error, setError] = useState(null); // Error state

//   // Fetch data from the API using Axios
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`${Constants.BASE_URL}?apitype=103`);
//         if (response.data.status && response.data.statusCode === 200) {
//           setEventData(response.data.mData[0]); // Assuming first event in the array
//         }
//       } catch (err) {
//         setError("Failed to fetch data");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Function to handle website button click
//   const handleWebsiteClick = () => {
//     if (eventData && eventData.link) {
//       window.open(eventData.link, "_blank");
//     }
//   };

//   // Loading and error handling
//   if (loading) {
//     return <div className="text-center mt-5">Loading...</div>;
//   }

//   if (error) {
//     return <div className="text-center mt-5 text-danger">{error}</div>;
//   }

//   return (
//     <div className="container mt-5">
//       <div className="row justify-content-center">
//         <div className="col-md-8 col-sm-10 col-12">
//           <div className="card">
//             <div className="card-body">
//               <h5 className="card-title">{eventData?.title}</h5>
//               <p className="card-text">
//                 {eventData?.descr.split("<br>").map((line, index) => (
//                   <span key={index}>
//                     {line}
//                     <br />
//                   </span>
//                 ))}
//               </p>
//               <p><strong>Updated on: </strong>{new Date(eventData?.updated_on).toLocaleString()}</p>
//               <button className="btn btn-primary" onClick={handleWebsiteClick}>
//                 Visit Website
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentsCorner;

import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
import * as Constants from "../Constants/Constants";

const StudentsCorner = () => {
  const [eventData, setEventData] = useState([]); // State to hold multiple events
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  // Fetch data from the API using Axios
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${Constants.BASE_URL}?apitype=103`);
        if (response.data.status && response.data.statusCode === 200) {
          setEventData(response.data.mData); // Set the entire array of events
        }
      } catch (err) {
        setError("Failed to fetch data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Function to handle website button click
  const handleWebsiteClick = (link) => {
    if (link) {
      window.open(link, "_blank");
    }
  };

  // Loading and error handling
  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (error) {
    return <div className="text-center mt-5 text-danger">{error}</div>;
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-sm-10 col-12">
          {eventData.length > 0 ? (
            eventData.map((event, index) => (
              <div key={index} className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title">{event.title}</h5>
                  <p className="card-text">
                    {event.descr.split("<br>").map((line, lineIndex) => (
                      <span key={lineIndex}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                  <p>
                    <strong>Updated on: </strong>
                    {new Date(event.updated_on).toLocaleString()}
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleWebsiteClick(event.link)}
                  >
                    Visit Website
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">No events available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentsCorner;

